import { Consumer } from '../Context'
import Loader from './Loader'

export default function ExistingIncidents() {
  return (
    <Consumer>
      {(props) => (
        <form onSubmit={props.clearIncidents}>
          <div className="form-group mb-5">
            <span className="existing-incidents-label d-block mb-2">
              Please Select an Existing Incident or Create a New Incident:
            </span>
            <div className="existing-incidents">
              {props.student.incidents.map((incident) => (
                <button
                  type="button"
                  key={incident.id}
                  className="incident"
                  disabled={props.loading}
                  onClick={() => props.updateIncident(incident.id)}
                >
                  {incident.name}
                </button>
              ))}
            </div>
          </div>
          <button
            type="submit"
            disabled={props.loading}
            className="d-flex btn btn-primary ml-auto button__load"
          >
            {props.loading ? <Loader /> : <span>New Incident</span>}
          </button>
        </form>
      )}
    </Consumer>
  )
}
